import { css } from "@emotion/css";
import Skeleton from "@mui/material/Skeleton";

export const FolderItemSkeleton = () => {
	return (
		<Skeleton
			variant="rounded"
			height={150}
			className={css`border-radius: 24px;`}
		/>
	);
};
